import React, { useState, useEffect } from 'react'
import httpHelper from 'utils/http-helper'
import URL_CONSTANTS from 'constants/url-constants'
import { Method_TYPE } from 'utils/http-helper'
import DataTable from 'react-data-table-component'
import ReportHeader from './ReportHeader'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { convertToIST } from 'utils/formtaDate'
import {
  useFilteredSortedData,
  ReportTableControls,
  ExportButtons,
} from './reportTableUtils'

const SEARCHABLE_FIELDS = ['name', 'description', 'required', 'registered', 'needed']

export default function Deployment() {
  const [deploymentDetails, setDeploymentDetails] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    getDeploymentDetail()
  }, [])

  const getDeploymentDetail = async () => {
    try {
      const data = await httpHelper(URL_CONSTANTS.GET_DEPLOYMENT_DETAILS, Method_TYPE.GET)
      setDeploymentDetails(
        data.map((tableData) => ({
          name: tableData?.name,
          description: tableData?.description,
          required: tableData?.required,
          registered: tableData?.registered,
          needed: tableData?.needed,
        }))
      )
    } catch (err) {
      console.error('Error fetching deployment details:', err)
      setDeploymentDetails([])
    }
  }

  const filteredData = useFilteredSortedData(deploymentDetails, {
    searchTerm,
    searchableFields: SEARCHABLE_FIELDS,
    sortBy: null,
  })

  const getBatchInfo = () => {
    const batchData = JSON.parse(localStorage.getItem('currentBatch'))
    if (batchData) {
      return `${batchData.name}:${convertToIST(batchData.startDate)} - ${convertToIST(batchData.endDate)}`
    }
    return ''
  }

  const columns = [
    {
      name: 'Sl.No',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
    },
    { name: 'Name', selector: row => row.name, sortable: true, cell: row => <div data-title="Name">{row.name}</div> },
    { name: 'Description', selector: row => row.description, sortable: true, cell: row => <div data-title="Description">{row.description}</div> },
    { name: 'Required', selector: row => row.required, sortable: true, cell: row => <div data-title="Required">{row.required}</div> },
    { name: 'Registered', selector: row => row.registered, sortable: true, cell: row => <div data-title="Registered">{row.registered}</div> },
    { name: 'Needed', selector: row => row.needed, sortable: true, cell: row => <div data-title="Needed">{row.needed}</div> },
  ]

  const handlePrint = () => {
    const printContent = document.getElementById('print-table').innerHTML
    const printWindow = window.open('', '', 'height=600,width=800')
    printWindow.document.write('<html><head><title>Deployment Report</title></head><body>')
    printWindow.document.write(`<h2>TamilNadu Prasanthi Seva - Deployment Report</h2><p><strong>${getBatchInfo()}</strong></p>`)
    printWindow.document.write(printContent)
    printWindow.document.write('</body></html>')
    printWindow.document.close()
    printWindow.focus()
    printWindow.print()
    printWindow.close()
  }

  const handleDownloadPDF = () => {
    const doc = new jsPDF()
    doc.text('Deployment Report', 14, 10)
    doc.text(`${getBatchInfo()}`, 14, 18)
    autoTable(doc, {
      startY: 20,
      head: [['Sl.No', 'Name', 'Description', 'Required', 'Registered', 'Needed']],
      body: filteredData.map((row, index) => [
        index + 1,
        row.name,
        row.description,
        row.required,
        row.registered,
        row.needed,
      ]),
    })
    doc.save('deployment-report.pdf')
  }

  const handleDownloadXLS = () => {
    const exportData = filteredData.map((item, index) => ({
      'Sl.No': index + 1,
      Name: item.name,
      Description: item.description,
      Required: item.required,
      Registered: item.registered,
      Needed: item.needed,
    }))
    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Deployment')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' })
    saveAs(data, 'deployment-report.xlsx')
  }

  return (
    <>
      <ReportTableControls
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchPlaceholder="Search name, description, required, registered, needed..."
        totalCount={deploymentDetails.length}
        filteredCount={filteredData.length}
        actions={
          <ExportButtons
            show={deploymentDetails.length > 0}
            onPrint={handlePrint}
            onPdf={handleDownloadPDF}
            onXls={handleDownloadXLS}
          />
        }
      />

      <div id="datatable-area">
        <ReportHeader header='Deployment Report' />
        <DataTable
          columns={columns}
          data={filteredData}
          fixedHeader
          fixedHeaderScrollHeight='500px'
          defaultSortFieldId={2}
          className='reports-table'
          noDataComponent={
            <div className="py-10 text-sm text-slate-500">
              {searchTerm.trim() ? 'No rows match your search' : 'No deployment data available'}
            </div>
          }
        />
      </div>

      <div id="print-table" style={{ display: 'none' }}>
        <table border="1" cellPadding="5" cellSpacing="0" width="100%">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Name</th>
              <th>Description</th>
              <th>Required</th>
              <th>Registered</th>
              <th>Needed</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>{item.required}</td>
                <td>{item.registered}</td>
                <td>{item.needed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
